<style lang="scss" scoped>
.sync {
  float: right;
  background: #17cfb8;
  border-color: #17cfb8;
  i {
    font-size: 20px;
    vertical-align: -2px;
    margin-right: 5px;
  }
}
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <tab :arr="arr"></tab>
      <el-button type="primary" class="sync" @click="asyncmaterial">
        <i class="iconfont icontongbubiaojiegou"></i>微信端素材同步
      </el-button>
    </div>
    <router-view class="h100" ref="child"></router-view>
  </div>
</template>

<script>
import tab from '@/components/tab';
export default {
  components: {
    tab,
  },
  computed: {},
  props: ['id'],
  data() {
    return {
      type: this.$route.path,
      arr: [
        {
          name: '图文消息',
          url: `/third/${this.id}/lib/article`,
        },
        {
          name: '图片',
          url: `/third/${this.id}/lib/image`,
        },
        {
          name: '语音',
          url: `/third/${this.id}/lib/sound`,
        },
        {
          name: '视频',
          url: `/third/${this.id}/lib/video`,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    router() {
      this.$router.push(this.type);
    },
    async asyncmaterial() {
      let res = await this.$http.get(`/api/${this.id}/material/async`);
      if (res) {
        await this.$refs.child.getData();
        this.$message.success('同步成功');
      }
    },
  },
};
</script>
